// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zu_jaawXYJk1A71g9mTR{flex-direction:column;gap:12px;display:flex}._MBrZddEyP07zznTVDSH{padding:2px 0!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"knowledgeBaseContainer": `Zu_jaawXYJk1A71g9mTR`,
	"knowledgeBaseLinkButton": `_MBrZddEyP07zznTVDSH`
};
export default ___CSS_LOADER_EXPORT___;
